import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import {useLocalization} from 'localization';
import type {DataLoadStatus} from 'api';
import type {Company} from 'services/companies';
import {ContactSubPanel} from './ContactSubPanel';
import {ManifestationSubPanelCard} from './ManifestationCard/components/ManifestationSubPanelCard';
import {ManifestationPanelContainer} from './ManifestationPanelContainer';

type Props = {
  companies: DataLoadStatus<Company[]>;
  onClose: () => void;
};

export const ContactPanel: React.FC<Props> = ({companies, onClose}) => {
  const {t} = useLocalization();

  if (companies.status === 'Loading') {
    return <CircularProgress />;
  }

  if (!companies?.data) {
    return null;
  }

  return (
    <ManifestationPanelContainer
      title={t('page.metadata.manifestation.tools.contact')}
      icon={'Building'}
      onClose={onClose}>
      {(companies.data ?? []).map(company => (
        <ManifestationSubPanelCard key={company.id}>
          <ContactSubPanel {...company} />
        </ManifestationSubPanelCard>
      ))}
    </ManifestationPanelContainer>
  );
};
